// angular
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

// services
import { AuthenticationService } from '../../services/authentication.service';

/*
 *  This component is used for impersonation and enter account. Should be sent here from admin with a jwt.
 */
@Component({
  template: `<!-- no template -->`,
  // tslint:disable-next-line: component-selector
  selector: 'app-exchange',
})
export class AuthenticationExchangeComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      const token: string = params['jwt'];

      try {
        this.auth.exchange(token).subscribe(() => {
          this.router.navigate(['/login-success']);
        });
      } catch {
        this.router.navigate(['/auth/login']);
      }
    });
  }
}
